module.exports = {
    personInfo: {
        userinfo: 'ユーザー情報',
        head: 'アバター',
        name: 'ユーザー名',
        nameMsg: '名前を入力してください',
        username: 'お名前',
        usernameMsg: '名前を入力してください',
        password: 'パスワード',
        passwordMsg: 'パスワードを入力してください',
        repeatPassword: 'パスワードを確認',
        repeatPasswordMsg: 'もう一度パスワードを入力してください',
        save: '保存',
        saving: '保存しています...',
        validMsg: { //校验提示信息 確認プロンプト情報
            nickName: '名前を入力してください',
            password: 'パスワードを入力してください',
            length1: '6-20桁のパスワードを入力してください',
            length2: '6〜20個のパスワードを繰り返し入力してください',
            password2: 'もう一度パスワードを入力してください',
            passRule: 'ユーザーパスワードにスペースを含めることはできません',
            passRule2: 'ユーザーパスワードに中国語を含めることはできません',
            disPw: '2つのパスワードに矛盾があります'
        },
        hintMsg: { //数据交互提示信息  データ対話プロンプト情報
            dialogTitle: '修正',
            sure: '確定',
            updateSuccess: 'ユーザーの個人情報の変更の成功',
            // miss:'缺少请求参数', リクエストパラメータがありません
            updateFail: '個人情報の変更に失敗しました',
            queryFail: 'ユーザー情報のクエリに失敗しました'
        },
        upload: {
            format: 'アップロードしたアバター画像はJPGおよびPNG形式でなければなりません!',
            size: '画像サイズは200 * 200以内である必要があります!',
            fail: 'アップロードに失敗しました'

        }


    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/personInfo.js